import React, {createContext, useState} from 'react';
import {SearchOutlined} from '@ant-design/icons';
import {Card, Checkbox, Col, Collapse, Form, Row, Select, Space, TreeSelect} from 'antd';
import {ProForm, ProFormSelect, ProFormTreeSelect} from '@ant-design/pro-components';
import {ProFormDateRangePicker} from '@ant-design/pro-form/lib/components';
import DynamicSelect from './Components/DynamicSelect';
import {atom, useAtom} from 'jotai';
import qs from 'qs';
import {countryTreeOptions, genreOptions} from '../common/ddex_options'

const {Option} = Select;


export type Searchcriteria = {
    upc: string;
    isrc: string;
    name: string;
    original_release_date: Date;
    digital_release_date: Date;
    genre: string;
    label: string;
    asset_label: string;
    artist: string[];
    territories: string[];
    type: ('Album' | 'Single' | 'Ep')[];
    uploaded_to: ('Youtube' | 'Believe' | 'Spotify')[];
};

type FormValues = {
    UPC: string;
    ISRC: string;
    Title: string;
    Artist: string[];
    Label: string[];
    AssetLabel: string;
    ReleaseDate: [string, string];
    ReleaseType: string;
    Genre: string;
    Territories: string[];
    uploaded_to: string[];
};

type OptionTypes = { label: string; value: string };
const OptionsContext = createContext<OptionTypes[]>([]);

const {SHOW_PARENT} = TreeSelect;

export const waitTime = (time: number = 100) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, time);
    });
};
<Select maxLength={10} maxTagCount={10} maxTagPlaceholder={10} children={ProFormSelect}></Select>;

export const searchCriteriaAtom = atom<Partial<Searchcriteria>>({});
export const searchParamsAtom = atom<Partial<Searchcriteria>>({});
export const queryAtom = atom<string>('');

// const SearchForm: React.FC<{
//     onSearchSubmit: (data: any[], isDigitalAssets: boolean) => void;
// }> = ({ onSearchSubmit }) => {
const SearchForm = () => {
    // const [, setSearchCriteria] = useAtom(searchCriteriaAtom);
    const {Panel} = Collapse;
    const [queryAtomValue, setQueryAtomValue] = useAtom(queryAtom);
    const [isModalVisible, setIsModalVisible] = useState(false);
    // const [responseData, setResponseData] = useState<any[]>([]);
    const handleSubmit = async (values: FormValues) => {
        const transformedValues = {
            ...values,
            uploaded_to: Array.isArray(values.uploaded_to) ? values.uploaded_to.join(',') : ''
        };

        const queryString = qs.stringify(transformedValues, {
            arrayFormat: 'comma',
            encode: false
        });

        setQueryAtomValue(queryString);
        // setIsModalVisible(true);

        // const response = await axiosApiInstance.get(`/api/digitalassets/search?${queryString}`);

        // const responseData = response.data?.data ?? [];
        // setQueryAtomValue(queryString);
        // setResponseData(responseData || []);
        // onSearchSubmit(responseData, true);

        // setSearchParams(responseData || []);

        // if (!Array.isArray(responseData)) {
        //     throw new Error('Invalid response format: Expected an array.');
        // }
    };

    // const ResponseData = responseData;

    return (
        <Card
            style={{
                marginBottom: "4px",
            }}
        >
            <Collapse ghost>
                <Panel extra={<SearchOutlined/>} header="Search Form" key="1">
                    <ProForm<FormValues> onFinish={handleSubmit}>
                        <ProForm.Group align="baseline">
                            <DynamicSelect
                                mode={"multiple"}
                                name="upc"
                                label="UPC"
                                rules={[{required: false}]}
                                placeholder="Select UPC code"
                                endpoint="/api/digitalassets/upc/daoptions?timestamp="
                                targetField="upc"
                            />

                            <DynamicSelect
                                mode={"multiple"}
                                name="name"
                                label="Release Title"
                                rules={[{required: false}]}
                                placeholder="Select Release Title "
                                endpoint="/api/digitalassets/name/daoptions?timestamp="
                                targetField="name"
                            />

                            <DynamicSelect
                                mode={"multiple"}
                                name="isrc"
                                label="ISRC"
                                rules={[{required: false}]}
                                placeholder="Select ISRC code"
                                endpoint="/api/digitalassets/isrc/daoptions?timestamp="
                                targetField="isrc"
                            />
                        </ProForm.Group>
                        <ProForm.Group>
                            <DynamicSelect
                                mode={"multiple"}
                                name="artist"
                                label="Artist"
                                rules={[{required: false}]}
                                placeholder="Select Artist "
                                endpoint="/api/digitalassets/daoptions?timestamp="
                                targetField="artist"
                            />
                            <DynamicSelect
                                mode={"multiple"}
                                name="label"
                                label="Label"
                                rules={[{required: false}]}
                                placeholder="Select Label "
                                endpoint="/api/digitalassets/label/options?timestamp="
                                targetField="label"
                            />

                            <DynamicSelect
                                mode={"multiple"}
                                name="asset_label"
                                label="Asset Label"
                                rules={[{required: false}]}
                                placeholder="Select Asset Label"
                                endpoint="/api/digitalassets/assetlabel/options?timestamp="
                                targetField="asset_label"
                            />
                        </ProForm.Group>

                        <ProForm.Group>
                            <ProFormTreeSelect
                                label="Territories"
                                name="territories"
                                request={async () => countryTreeOptions}
                                fieldProps={{
                                    showCheckedStrategy: SHOW_PARENT,
                                    showSearch: true,
                                    treeCheckable: true,
                                    maxTagCount: 5,
                                }}
                                width={300}
                            />
                            <ProFormSelect
                                mode={"multiple"}
                                name="genre"
                                label="Genre"
                                rules={[{required: false}]}
                                placeholder="Select Genre "
                                options={genreOptions}
                                width={300}
                            />
                        </ProForm.Group>
                        <ProForm.Group>
                            <ProFormDateRangePicker
                                name="original_release_date"
                                label="Release Date"
                            />
                            <Row>
                                {/* <Form.Item name='uploaded_to' label='Platform'>
                            <Checkbox.Group onChange={(value) => {}}>
                                <Row>
                                    <Col span={14}>
                                        <Checkbox value='Spotify'>Spotify</Checkbox>
                                    </Col>
                                    <Col span={14}>
                                        <Checkbox value='YouTube'>YouTube</Checkbox>
                                    </Col>
                                    <Col span={14}>
                                        <Checkbox value='Believe'>Believe</Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                        </Form.Item> */}
                                <Form.Item name="type" label="Release Type">
                                    <Checkbox.Group
                                        onChange={(value) => {
                                            // value = searchCriteria.uploaded_to;
                                        }}
                                    >
                                        <Row>
                                            <Col span={14}>
                                                <Checkbox value="Album">Album</Checkbox>
                                            </Col>
                                            <Col span={14}>
                                                <Checkbox value="Ep">Ep</Checkbox>
                                            </Col>
                                            <Col span={14}>
                                                <Checkbox value="Single">Single</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>
                                </Form.Item>
                            </Row>
                        </ProForm.Group>

                        <Form.Item wrapperCol={{span: 12, offset: 6}}>
                            <Space></Space>
                        </Form.Item>
                    </ProForm>
                </Panel>
            </Collapse>
        </Card>
    );
};
export default SearchForm;